import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.OrganizationSetup';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class OrganizationSetup extends RpcClass{

    /**
     *  @class OrganizationSetup
     *  @alias module:src/server/com/silkplm/rpc/OrganizationSetup.OrganizationSetup
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteLoginPageImage() {
            return RpcClass.rpcCall('/rpc/organization-setup/delete-login-page-image', []);
    }
    /** 
     * @async
     * @param accountDeletionMessage {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteMyOrganization(accountDeletionMessage) {
            return RpcClass.rpcCall('/rpc/organization-setup/delete-my-organization', [accountDeletionMessage]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     deleteNavigationBarImage() {
            return RpcClass.rpcCall('/rpc/organization-setup/delete-navigation-bar-image', []);
    }
    /** 
     * @async
     * @param organization {module:src/server/com/silkplm/model/users/Organization.Organization} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<*>}
     */
     editMyOrganization(organization) {
            return RpcClass.rpcCall('/rpc/organization-setup/edit-my-organization', [organization]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/plm/dictionaries/Currency.Currency[]>}
     */
     getCurrencies() {
            return RpcClass.rpcCall('/rpc/organization-setup/get-currencies', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Organization.Organization>}
     */
     getSessionOrganizationInfo() {
            return RpcClass.rpcCall('/rpc/organization-setup/get-session-organization-info', []);
    }
    /** 
     * @async
     * @param file {File} 
     * @param minWidth {number} 
     * @param minHeight {number} 
     * @param maxWidth {number} 
     * @param maxHeight {number} 
     * @param name {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository>}
     */
     uploadImage(file, minWidth, minHeight, maxWidth, maxHeight, name) {
            return RpcClass.rpcCallMultipart('/rpc/organization-setup/upload-image', [file, minWidth, minHeight, maxWidth, maxHeight, name]);
    }
    /** 
     * @async
     * @param file {File} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository>}
     */
     uploadLoginPageImage(file) {
            return RpcClass.rpcCallMultipart('/rpc/organization-setup/upload-login-page-image', [file]);
    }
    /** 
     * @async
     * @param file {File} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/files/FileInRepository.FileInRepository>}
     */
     uploadNavigationBarImage(file) {
            return RpcClass.rpcCallMultipart('/rpc/organization-setup/upload-navigation-bar-image', [file]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.OrganizationSetup';
metadata.__type_short__ = 'OrganizationSetup';
OrganizationSetup.prototype.__metadata__ = metadata;

OrganizationSetup.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/OrganizationSetup */
export default OrganizationSetup

export { OrganizationSetup }
